module.exports = __webpack_public_path__ + "static/media/vienna.1ae15004.jpg";